import { inject, observer } from "mobx-react";
import React from 'react';
import videoIcon from '~/assets/img/video/loading.gif';

/*
TODO изменить строку на локале, коггда будет готов перевод
 */
export default inject('dictStore')(observer(({ dictStore, videoError }) => (
  <div className='loading-spinner-video'>
    {!videoError ? <img src={ videoIcon } className='loading-spinner-video-spinner' alt="loading"/> : ""}
    <div className='relative'>
      <div className='absolute loading-spinner-video-text'>
        {dictStore.getLang(videoError ? 'SORRY_VIDEO_IS_NOT_AVAILABLE' : 'VIDEO_LOADING_PLEASE_WAIT')}
      </div>
    </div>
  </div>
)));


// WEBPACK FOOTER //
// ./src/components/videoplayer/loading.js